export const OTP_LOADING_LABEL = 'Preparing two-factor authentication.';
export const OTP_COMPLETING_LABEL = 'Preparing your next step.';
export const UNKNOWN_OTP_ERROR_MESSAGE = 'Unknown error';
